import QRCode from "react-qr-code";
import styles from "./styles.module.scss";
import { images } from "src/assets/images/images";
import { useAppSelector } from "src/hooks/useRedux";
import { TEXT_TAGS } from "src/utils/enums";
import { UIText } from "../uIKit";
import { useIsMobile } from "src/hooks/useIsMobile";

interface QrCardProps {
  value: string;
  androidUrl: string;
  iosUrl: string;
}

const QrCard = ({ value, androidUrl, iosUrl }: QrCardProps) => {
  const { strings } = useAppSelector((state) => state.app);
  const isMobile = useIsMobile();


  return (
    <div className={styles.card}>
      <div className={styles.header}>
        {/* <h2 className={styles.title}>{strings.t_passportCard_il}</h2> */}
        <UIText
          text={strings.t_passportCard_il}
          tag={TEXT_TAGS.H2}
          size={18}
          weight={500}
        />

        <img src={images.smallLogo} alt="Logo" className={styles.logo} />
      </div>
      {!isMobile && (
        <div className={styles.qrContainer}>
          <QRCode value={value} size={94} title="" />
        </div>
      )}

      <div className={styles.imagesContainer}>
        {isMobile ? (
          <>
            <img
              src={images.appstore}
              alt="Download on App Store"
              className={styles.storeButton}
            />

            <img
              src={images.googleplay}
              alt="Get it on Google Play"
              className={styles.storeButton}
            />

          </>
        ) : (
          <>
            <div className={styles.storeButton}>
              <img
                src={images.appstore}
                alt="Download on App Store"
                className={styles.image}
              />
            </div>
            <div className={styles.storeButton}>
              <img
                src={images.googleplay}
                alt="Get it on Google Play"
                className={styles.image}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default QrCard;
